import { render, staticRenderFns } from "./ReviewComment.vue?vue&type=template&id=6a03df93&scoped=true&"
import script from "./ReviewComment.vue?vue&type=script&lang=js&"
export * from "./ReviewComment.vue?vue&type=script&lang=js&"
import style0 from "./ReviewComment.vue?vue&type=style&index=0&id=6a03df93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a03df93",
  null
  
)

export default component.exports